module.exports = __webpack_public_path__ + "img/alert.f02cce4c.svg";